var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0453 1H6.04538C3.28397 1 1.04541 3.23858 1.04541 6V16C1.04541 18.7614 3.28397 21 6.04538 21H16.0453C18.8067 21 21.0453 18.7614 21.0453 16V6C21.0453 3.23858 18.8067 1 16.0453 1Z",
    stroke: "var(--klothed-textColor)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.045 10.4133C15.1685 11.2455 15.0263 12.0955 14.6388 12.8423C14.2513 13.5891 13.6382 14.1947 12.8867 14.5729C12.1352 14.9512 11.2835 15.0829 10.4529 14.9492C9.62222 14.8155 8.85486 14.4233 8.25995 13.8284C7.66503 13.2335 7.27285 12.4661 7.13918 11.6355C7.00552 10.8048 7.13718 9.95316 7.51544 9.20164C7.8937 8.45012 8.49929 7.83701 9.24608 7.44951C9.99288 7.06201 10.8428 6.91986 11.6751 7.04327C12.524 7.16915 13.3099 7.56473 13.9168 8.17158C14.5236 8.77842 14.9192 9.56434 15.045 10.4133Z",
    stroke: "var(--klothed-textColor)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54541 11H4.55541",
    stroke: "var(--klothed-textColor)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.625c34c1c540de42a072a828c57e7cf5.svg";
export { ForwardRef as ReactComponent };